<template>
  <div>
    <router-view
      v-model:answer.sync="answer"
      v-model:answer_comment.sync="answer_comment"
      >
    </router-view>
  </div>
</template>
